export default {
      id: "menu__delete_fill-usage",
      viewBox: "-3 0 24 20",
      url: __webpack_public_path__ + "img/icons.svg#menu__delete_fill",
      toString: function () {
        return this.url;
      }
    }